var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-system-bar',{attrs:{"window":"","dark":""}},[_c('v-icon',[_vm._v("mdi-message")]),_c('span',[_vm._v("10 unread messages")]),_c('v-spacer'),_c('v-icon',[_vm._v("mdi-minus")]),_c('v-icon',[_vm._v("mdi-checkbox-blank-outline")]),_c('v-icon',[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }